import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";

interface MixIdeal {
  cd_fornecedor: number;
  ds_fornecedor: string;
}

export const useMixIdeal = () => {
  return useQuery<MixIdeal[]>({
    queryKey: queryKeys.mixIdeal,
    queryFn: async () => {
      const response = await api.get("mix-ideal");
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};
